import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendBlogPostBuilderOutlineSection,
  BackendMutationDeleteBlogPostBuilderOutlineSectionArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation DeleteBlogPostBuilderOutlineSection($id: ID!) {
    deleteBlogPostBuilderOutlineSection(id: $id) {
      id
    }
  }
`;

type Variables = BackendMutationDeleteBlogPostBuilderOutlineSectionArgs;
type Result = Pick<BackendBlogPostBuilderOutlineSection, 'id'>;

export const deleteBlogPostBuilderOutlineSection = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
